import React, { useEffect, useState } from 'react'
import { Btn, BtnIcon, CustomDropdown, InputNumeroInteiro } from '../../../../components'
import {
  getDesdobramentos,
  saveDesdobramentos,
} from '../../../../services/api/https/registration/produto.http'
import { errorHandler } from '../../../../services/util/error.service'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { FaRegTrashAlt } from 'react-icons/fa'

export default function DesdobramentoProduto({ produtoId, onResponse }) {
  // Hooks
  const [desdobramentos, setDesdobramentos] = useState([])
  const [produtosCadastrados, setProdutosCadastrados] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (produtoId) {
      getDesdobramentos(produtoId)
        .then(info => {
          const { cadastro_produtos, desdobramentos_atuais } = info
          buildProdutosCadastrados(cadastro_produtos)
          buildDesdobramentos(desdobramentos_atuais)
          setIsLoading(false)
        })
        .catch(e => {
          setIsLoading(false)
          onResponse('error', errorHandler(e))
        })
    }
  }, [produtoId])

  const buildProdutosCadastrados = cadastro_produtos => {
    const options = cadastro_produtos.map(p => {
      const { product_code, name, id } = p
      return {
        label: product_code + ' - ' + name,
        value: id,
      }
    })
    setProdutosCadastrados(options.filter(o => o.value !== produtoId))
  }

  const buildDesdobramentos = desdobramentos_atuais => {
    // Novo Desdobramento - Blueprint
    desdobramentos_atuais.unshift({
      id: null,
      product_id_origem: produtoId,
      product_id_destino: '',
      fator: '',
    })

    // State
    setDesdobramentos(desdobramentos_atuais)
  }

  const refreshDesdobramentos = item => {
    setDesdobramentos(prev => {
      const i = prev.findIndex(p => p.id === item.id)
      if (i !== -1) {
        prev[i] = item
      }
      return [...prev]
    })
  }

  const checkConsistencia = () => {
    const desdobramentosInconsistentes = []
    desdobramentos.forEach(d => {
      if (
        (d.product_id_destino !== '' && (d.fator === '' || d.fator <= 0)) ||
        (d.product_id_destino === '' && d.fator !== '')
      ) {
        desdobramentosInconsistentes.push(d)
      }
    })
    return desdobramentosInconsistentes
  }

  // Events
  const btnSalvarClick = async () => {
    try {
      const desdobramentosInconsistentes = checkConsistencia()
      if (desdobramentosInconsistentes.length > 0) {
        onResponse('error', 'Existe desdobramento(s) incorreto(s). Favor verifique.')
      } else {
        setIsLoading(true)
        const desdobramentos_atuais = await saveDesdobramentos(
          desdobramentos.filter(d => d.product_id_destino !== '' && d.fator !== ''),
          produtoId,
        )
        buildDesdobramentos(desdobramentos_atuais)
        onResponse('success', 'Operação realizada com sucesso')
      }
    } catch (e) {
      onResponse('error', errorHandler(e))
    } finally {
      setIsLoading(false)
    }
  }

  const onApagar = item => {
    if (item.id === null) {
      item.product_id_destino = ''
      item.fator = ''
      refreshDesdobramentos(item)
    } else {
      setDesdobramentos(d => {
        return d.filter(d => d.id !== item.id)
      })
    }
  }

  const onProdutoChange = (item, productId) => {
    item.product_id_destino = productId
    refreshDesdobramentos(item)
  }
  const onFatorChange = (item, fator) => {
    item.fator = fator
    refreshDesdobramentos(item)
  }

  // Render
  return (
    <div className="p-grid" style={{ width: 625 }}>
      <div className="p-col-12">
        <Btn isLoading={isLoading} onClick={btnSalvarClick}>
          Salvar
        </Btn>
      </div>
      <div className="p-col-12">
        <DataTable
          value={desdobramentos}
          emptyMessage={'Não existe desdobramento cadastrado para este produto'}
          loading={isLoading}
        >
          <Column
            header={'Equivale'}
            style={tableCellCentered()}
            body={item => (
              <InputNumeroInteiro
                onChange={fator => onFatorChange(item, fator)}
                marginTop={0}
                value={item.fator}
              />
            )}
          />
          <Column
            header={'Produto'}
            body={item => (
              <CustomDropdown
                marginTop={0}
                value={item.product_id_destino}
                onChange={productId => onProdutoChange(item, productId)}
                filter={true}
                showLabel={false}
                options={produtosCadastrados}
              />
            )}
          />
          <Column
            style={tableCellCentered(80)}
            body={item => (
              <BtnIcon onClick={() => onApagar(item)}>
                <FaRegTrashAlt color="red" size={18} />
              </BtnIcon>
            )}
          />
        </DataTable>
      </div>
    </div>
  )
}
